/**
 * Liest die Fehlermeldung aus einer Backend-Antwort.
 *
 * Das Backend liefert entweder `detail: "Text"` (FastAPI-Standard) oder
 * `detail: { code, message, ... }` (strukturiertes Fehlerformat, z. B. bei 2FA).
 */
export function readApiError(error: unknown, fallback: string): string {
  // `error` kann null oder ein einfacher Error sein — der Zugriff muss das aushalten,
  // sonst reisst ein fehlender Fehler die ganze Seite mit.
  const detail = (error as { response?: { data?: { detail?: unknown } } } | null)
    ?.response?.data?.detail;

  if (typeof detail === 'string') return detail;

  if (detail && typeof detail === 'object' && 'message' in detail) {
    return String((detail as { message: unknown }).message);
  }

  return fallback;
}

/** Fehlercode aus dem strukturierten Fehlerformat, z. B. "totp_required". */
export function readApiErrorCode(error: unknown): string | null {
  const detail = (error as { response?: { data?: { detail?: unknown } } } | null)
    ?.response?.data?.detail;

  if (detail && typeof detail === 'object' && 'code' in detail) {
    return String((detail as { code: unknown }).code);
  }
  return null;
}
